import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {CopilotCodeReviewFeedback} from './CopilotCodeReviewFeedback'

registerReactPartial('copilot-code-review-feedback', {
  Component: CopilotCodeReviewFeedback,
})
